<template>
  <div>
    <v-btn color="primary" dark @click="dialog = true">filedan yuklash</v-btn>
    <v-dialog v-model="dialog" max-width="300" persistent>
      <v-card>
        <v-card-title class="headline">CSV YUKLASH</v-card-title>
        <v-card-text>
          <v-file-input
              accept=".csv"
              chips
              label="File (cvs max 2MB)"
              outlined
              show-size
              @change="onCsvUpload($event)"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-btn color="green darken-1" text @click="dialog = false"
          >ORTGA
          </v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="uploadCsv()"
          >YUKLASH
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUploaded" max-width="700" persistent>
      <v-card>
        <v-card-title class="headline">YUKLANGANLAR</v-card-title>
        <v-card-text>
          <v-data-table :headers="headers" :items="items" hide-default-footer></v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="green darken-1" text @click="dialogUploaded = false"
          >ORTGA
          </v-btn
          >
          <v-spacer></v-spacer>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar :value="snackbar" bottom color="red" outlined right>
      Fileda xatolik bor
    </v-snackbar>
  </div>
</template>

<script>
import service from './book.service'

export default {
  name: "CSVUpload",
  data: () => ({
    csvFile: null,
    dialog: false,
    dialogUploaded: false,
    snackbar: false,
    uploadedBooks: [],
    headers: [
      {
        text: "NOMI",
        value: "name",
        divider: "true",
        align: "start",
      },
      {
        text: "AVTOR",
        value: "author",
        divider: "true",
        align: "center",
      },
      {
        text: "YIL",
        value: "year",
        divider: "true",
        align: "center",
      },
      {
        text: "KAFEDRA",
        value: "departmentId",
        divider: "true",
        align: "center",
      },
      {
        text: "BO'LIM",
        value: "categoryId",
        divider: "true",
        align: "center",
      },
    ],
  }),
  methods: {
    onCsvUpload(e) {
      this.csvFile = e;
    },
    onUploadProgress() {
    },
    uploadCsv() {
      service.upload(this.csvFile, this.onUploadProgress()).then(res => {
        this.uploadedBooks = res.data
        setTimeout(() => {
          this.dialog = false
          this.dialogUploaded = true
        }, 400)
      })
    },
  },
  computed: {
    items() {
      return this.uploadedBooks;
    }
  }
}
</script>

<style scoped>

</style>